/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ expiresAtString: NonNullable<unknown> }} Subscription_Canceled_Valid_UntilInputs */

const en_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscription renewal has been canceled. Your current subscription is valid until ${i?.expiresAtString}.`)
};

const id_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perpanjangan langganan telah dibatalkan. Langganan Anda saat ini berlaku hingga ${i?.expiresAtString}.`)
};

const ms_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pembaharuan langganan telah dibatalkan. Langganan anda sekarang ini sah sehingga ${i?.expiresAtString}.`)
};

const ca_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`S'ha cancel·lat la renovació de la subscripció. La teva subscripció actual serà vàlida fins al ${i?.expiresAtString}.`)
};

const cs_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obnovení předplatného bylo zrušeno. Vaše aktuální předplatné platí do ${i?.expiresAtString}.`)
};

const da_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fornyelse af abonnementet er blevet annulleret. Dit nuværende abonnement er gyldigt indtil ${i?.expiresAtString}.`)
};

const de_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Verlängerung deines Abonnements wurde gekündigt. Dein aktuelles Abonnement läuft noch bis ${i?.expiresAtString}.`)
};

const et_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tellimuse uuendamine on tühistatud. Teie praegune tellimus kehtib kuni ${i?.expiresAtString}.`)
};

const es_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se canceló la renovación de tu suscripción. Tu suscripción actual es válida hasta el ${i?.expiresAtString}.`)
};

const fr_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre abonnement ne sera pas renouvelé. Il reste actif jusqu’au ${i?.expiresAtString}.`)
};

const hr_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Otkazano je obnavljanje pretplate. Vaša trenutačna pretplata vrijedi do ${i?.expiresAtString}.`)
};

const it_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il rinnovo dell'abbonamento è stato cancellato. Il tuo abbonamento corrente è valido fino alla data: ${i?.expiresAtString}.`)
};

const lv_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonementa atjaunošana ir atcelta. Jūsu pašreizējais abonements ir derīgs līdz ${i?.expiresAtString}.`)
};

const lt_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prenumeratos atnaujinimas buvo atšauktas. Jūsų dabartinė prenumerata galioja iki ${i?.expiresAtString}.`)
};

const hu_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Az előfizetés megújítása törlésre került. Jelenlegi előfizetése a ${i?.expiresAtString} címig érvényes.`)
};

const nl_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verlenging van het abonnement is geannuleerd. Je huidige abonnement is geldig tot ${i?.expiresAtString}.`)
};

const nb_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnementet vil ikke fornyes. Det nåværende abonnementet ditt varer til ${i?.expiresAtString}.`)
};

const pl_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odnowienie subskrypcji zostało anulowane. Twoja obecna subskrypcja jest ważna do ${i?.expiresAtString}.`)
};

const pt_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A renovação da assinatura foi cancelada. Sua assinatura atual permanece válida até ${i?.expiresAtString}.`)
};

const ro_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reînnoirea abonamentului a fost anulată. Abonamentul tău actual este valabil până la ${i?.expiresAtString}.`)
};

const sk_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obnovenie predplatného bolo zrušené. Vaše aktuálne predplatné je platné do ${i?.expiresAtString}.`)
};

const sl_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podaljšanje naročnine je bilo preklicano. Vaša trenutna naročnina velja do ${i?.expiresAtString}.`)
};

const fi_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tilauksen uusiminen on peruutettu. Nykyinen tilauksesi on voimassa ${i?.expiresAtString} asti.`)
};

const sv_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Förnyelsen av prenumerationen har avbrutits. Din nuvarande prenumeration är giltig fram till ${i?.expiresAtString}.`)
};

const vi_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã hủy gia hạn gói đăng ký. Gói đăng ký hiện tại của bạn sẽ hết hạn vào ngày ${i?.expiresAtString}.`)
};

const tr_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonelik yenileme işlemi iptal edilmiştir. Mevcut aboneliğiniz ${i?.expiresAtString} tarihine kadar geçerlidir.`)
};

const el_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Η ανανέωση της συνδρομής ακυρώθηκε. Η τρέχουσα συνδρομή σας ισχύει μέχρι τις ${i?.expiresAtString}.`)
};

const bg_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Подновяването на абонамента е отменено. Настоящият ти абонамент е валиден до ${i?.expiresAtString}.`)
};

const ru_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обновление подписки было отменено. Ваша текущая подписка действительна до ${i?.expiresAtString}.`)
};

const sr_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обнављање претплате је отказано. Ваша тренутна претплата важи до ${i?.expiresAtString}.`)
};

const uk_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Продовження підписки скасовано. Ваша поточна підписка дійсна до ${i?.expiresAtString}.`)
};

const ka_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`გამოწერის განახლება გაუქმდა. თქვენი მიმდინარე გამოწერა ძალაშია ${i?.expiresAtString}-მდე.`)
};

const hi_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सब्सक्रिप्शन रिन्यूअल रद्द कर दिया गया है। आपका करंट सब्सक्रिप्शन ${i?.expiresAtString} तक वैलिड है।`)
};

const th_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`การต่ออายุสมาชิกถูกยกเลิกแล้ว การเป็นสมาชิกปัจจุบันของคุณมีผลจนถึง ${i?.expiresAtString}`)
};

const ko_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`구독 갱신이 취소되었습니다. 현재 구독은 ${i?.expiresAtString}까지 유효합니다.`)
};

const zh_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`订阅续订已取消。您当前订阅的有效期截止 ${i?.expiresAtString}。`)
};

const zh_tw_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已取消續訂。您目前的訂閱有效期至 ${i?.expiresAtString}。`)
};

const ja_subscription_canceled_valid_until = /** @type {(inputs: Subscription_Canceled_Valid_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`サブスクリプションの更新がキャンセルされました。あなたの現在のサブスクリプションは、 ${i?.expiresAtString} まで有効です。`)
};

/**
* | output |
* | --- |
* | "Subscription renewal has been canceled. Your current subscription is valid until {expiresAtString}." |
*
* @param {Subscription_Canceled_Valid_UntilInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const subscription_canceled_valid_until = /** @type {((inputs: Subscription_Canceled_Valid_UntilInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Canceled_Valid_UntilInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_subscription_canceled_valid_until(inputs)
	if (locale === "ms") return ms_subscription_canceled_valid_until(inputs)
	if (locale === "ca") return ca_subscription_canceled_valid_until(inputs)
	if (locale === "cs") return cs_subscription_canceled_valid_until(inputs)
	if (locale === "da") return da_subscription_canceled_valid_until(inputs)
	if (locale === "de") return de_subscription_canceled_valid_until(inputs)
	if (locale === "et") return et_subscription_canceled_valid_until(inputs)
	if (locale === "es") return es_subscription_canceled_valid_until(inputs)
	if (locale === "fr") return fr_subscription_canceled_valid_until(inputs)
	if (locale === "hr") return hr_subscription_canceled_valid_until(inputs)
	if (locale === "it") return it_subscription_canceled_valid_until(inputs)
	if (locale === "lv") return lv_subscription_canceled_valid_until(inputs)
	if (locale === "lt") return lt_subscription_canceled_valid_until(inputs)
	if (locale === "hu") return hu_subscription_canceled_valid_until(inputs)
	if (locale === "nl") return nl_subscription_canceled_valid_until(inputs)
	if (locale === "nb") return nb_subscription_canceled_valid_until(inputs)
	if (locale === "pl") return pl_subscription_canceled_valid_until(inputs)
	if (locale === "pt") return pt_subscription_canceled_valid_until(inputs)
	if (locale === "ro") return ro_subscription_canceled_valid_until(inputs)
	if (locale === "sk") return sk_subscription_canceled_valid_until(inputs)
	if (locale === "sl") return sl_subscription_canceled_valid_until(inputs)
	if (locale === "fi") return fi_subscription_canceled_valid_until(inputs)
	if (locale === "sv") return sv_subscription_canceled_valid_until(inputs)
	if (locale === "vi") return vi_subscription_canceled_valid_until(inputs)
	if (locale === "tr") return tr_subscription_canceled_valid_until(inputs)
	if (locale === "el") return el_subscription_canceled_valid_until(inputs)
	if (locale === "bg") return bg_subscription_canceled_valid_until(inputs)
	if (locale === "ru") return ru_subscription_canceled_valid_until(inputs)
	if (locale === "sr") return sr_subscription_canceled_valid_until(inputs)
	if (locale === "uk") return uk_subscription_canceled_valid_until(inputs)
	if (locale === "ka") return ka_subscription_canceled_valid_until(inputs)
	if (locale === "hi") return hi_subscription_canceled_valid_until(inputs)
	if (locale === "th") return th_subscription_canceled_valid_until(inputs)
	if (locale === "ko") return ko_subscription_canceled_valid_until(inputs)
	if (locale === "zh") return zh_subscription_canceled_valid_until(inputs)
	if (locale === "zh-tw") return zh_tw_subscription_canceled_valid_until(inputs)
	if (locale === "ja") return ja_subscription_canceled_valid_until(inputs)
	return en_subscription_canceled_valid_until(inputs)
});